import { render, staticRenderFns } from "./WholesalerDateSells.vue?vue&type=template&id=9353a37c&scoped=true"
import script from "./WholesalerDateSells.vue?vue&type=script&lang=js"
export * from "./WholesalerDateSells.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9353a37c",
  null
  
)

export default component.exports